module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAABlBMVEUAAADX19f7b47VAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjYGA4AAAAxADBPcXUKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/@dp/mbase-style/src/less/dp/img/repeat-x-bottom-outline.png
// module id = 356
// module chunks = 4